import { Box, FormControlLabel, Switch as MuiSwitch } from "@mui/material";
import React, { SyntheticEvent } from "react";

export interface Props {
  label: string;
  checked?: boolean;
  defaultChecked?: boolean;
  onChange: (event: SyntheticEvent<Element, Event>, checked: boolean) => void;
  disabled?: boolean;
}

const Switch: React.FC<Props> = (props) => {
  return (
    <Box sx={{ paddingY: "10px" }}>
      <FormControlLabel
        disabled={props.disabled}
        control={<MuiSwitch defaultChecked={props.defaultChecked} />}
        label={props.label}
        color="primary"
        checked={props.checked}
        onChange={props.onChange}
        sx={{ margin: 0 }}
      />
    </Box>
  );
};

export default Switch;
